import { CopyToClipboardText } from "@dashboard/library";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

import { useCall } from "@/hooks/useCall/useCall";

export function SectionCallUuid() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <SectionLayout data-test="call-uuid-section">
      <SectionHeader>{t("call_context.call_uuid")}</SectionHeader>
      <CopyToClipboardText useFilledIcon>{call.uuid}</CopyToClipboardText>
    </SectionLayout>
  );
}
